export const compareFirstInSecondJSON = (firstObject, secondObject) => {
    const keys = Object.keys(firstObject)
    const result = {}

    if (firstObject && secondObject) {
        for (let i = 0; i < keys.length; i += 1) {
            let value = firstObject[keys[i]]

            if (value === ' ') {
                value = null
            }

            if (value !== secondObject[keys[i]]) {
                result[keys[i]] = value
            }
        }
    }

    if (firstObject && !secondObject) {
        for (let i = 0; i < keys.length; i += 1) {
            result[keys[i]] = firstObject[keys[i]]
        }
    }

    return result
}

export const parseToInt = (value) => {
    const price = typeof value === 'string' ? value.replace(/,/g, '') : value

    return parseFloat(price)
}

/**
 * Compare a given array of substrings with the given string.
 *
 * @param {string} needle
 * @param {array|string} haystack
 *
 * @return {array}
 */
export const stringContainsAnyOf = (needle, haystack) => [].concat(haystack).find(substring => needle.includes(substring))
/**
 * Compare a given array of substrings with the given string.
 *
 * @param {string} needle
 * @param {array|string} haystack
 *
 * @return {array}
 */
export const stringContainsExactlyOf = (needle, haystack) => [].concat(haystack).find(substring => needle === substring)

export const formatDecimalNumber = number =>
    Number.parseFloat(parseToInt(number)).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

/**
 * Format a given number to a fully formatted price. e.g. 10.12 -> $10.12 MXN
 *
 * @param {number} value
 * @param {{symbol: string, code: string}} currency
 *
 * @return {string} A formatted price
 */
export const formatPrice = (value, currency, getCode = false) => {
    if (!currency.symbol) {
        return formatDecimalNumber(value)
    }
    if (getCode && currency.code) {
        `${currency.symbol}${formatDecimalNumber(value)} ${currency.code}`
    }

    return `${currency.symbol}${formatDecimalNumber(value)}`
}

export const isTeacher = role => role === 'Teacher' || role === 'Nurse'

/**
 * Search for the given user role within the given array of roles.
 *
 * @param {string} user The needle
 * @param {array|string} roles The haystack
 *
 * @return {boolean}
 */
export const userHasRole = (user, roles) => user.role && !!stringContainsAnyOf(user.role, roles)

export const studentIsExternal = (student) => student.status_id && student.status_id === 5 || student.status_id === 6 ? true : false

export const stripEmptyValues = (parts, ...strings) => {
    let result = ''

    for (let i = 0; i < parts.length; i += 1) {
        if (i === 0 || parts[i] !== ' ' || strings[i]) {
            result += parts[i]
        }

        if (strings[i]) {
            result += strings[i]
        }
    }

    return result
}

export const parseFullName = (obj, returnNullIfNoFirstName = false) => {
    const { first_name, last_name_paternal, last_name_maternal = null } = obj

    if (returnNullIfNoFirstName && !first_name) {
        return ''
    }

    return stripEmptyValues `${first_name} ${last_name_paternal} ${last_name_maternal}`
}

export const slugify = text => (
    text.toString().toLowerCase()
    .normalize('NFD')
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[\u0300-\u036f]/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
)

export const getCookie = (cookieName) => {
    const name = `${cookieName}=`
    const decodeCookies = decodeURIComponent(document.cookie)
    const cookiesArray = decodeCookies.split(';')
    for (let i = 0; i < cookiesArray.length; i += 1) {
        let cookie = cookiesArray[i]
            // Quita los espacios en blanco
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1)
        }
        if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length)
        }
    }
    return undefined
}

/** Generate the options for the selects in checkin and checkout. The selects are: diaper, change of clothes and bag */
export const generateSelectOptions = (length = null, divide = 1) => {
    if (length > 0) {
        const total = (length + 1) * divide

        const options = new Array(total).fill().map((val, i) => ({
            label: (i / divide).toString(),
            value: (i / divide).toString(),
            id: (i / divide).toString(),
        }))

        return options
    }

    return []
}

// Helper function para convertir objetos Immutable a JavaScript normal
// reduxsauce-crud usa Immutable.js, así que necesitamos convertir todo recursivamente
export const toPlainObject = (obj) => {
    // Si es null o undefined, retornar tal cual
    if (obj === null || obj === undefined) {
        return obj
    }

    // Si es un objeto Immutable (tiene método toJS), convertirlo primero
    // toJS() ya convierte recursivamente, pero procesamos el resultado para asegurar
    if (obj && typeof obj.toJS === 'function') {
        return toPlainObject(obj.toJS())
    }

    // Si es un array, convertir cada elemento recursivamente
    if (Array.isArray(obj)) {
        return obj.map(item => toPlainObject(item))
    }

    // Si es un objeto JavaScript normal, convertir todas sus propiedades recursivamente
    // Verificar que sea un objeto plano (no Date, RegExp, etc.)
    if (typeof obj === 'object' && obj !== null && obj.constructor === Object) {
        const plainObj = {}
        for (const key in obj) {
            // Excluir propiedades internas de Immutable.js si aún existen
            if (obj.hasOwnProperty(key) && key !== '__immutable_invariants_hold') {
                plainObj[key] = toPlainObject(obj[key])
            }
        }
        return plainObj
    }

    // Para otros tipos (primitivos, Date, etc.), retornar tal cual
    return obj
}


// WEBPACK FOOTER //
// ./src/utils/Utils.js